export function checkUrl(possibleUrl: string): URL | undefined {
  try {
    const result = new URL(possibleUrl);
    return result;
  } catch {
    return undefined;
  }
}
